/* eslint-disable */
import React from 'react';
import classNames from 'classnames';
import styles from './Value.css';

const Value = React.createClass({

  displayName: 'Value',

  propTypes: {
    children: React.PropTypes.node,
    disabled: React.PropTypes.bool,               // disabled prop passed to ReactSelect
    id: React.PropTypes.string,                   // Unique id for the value - used for aria
    onRemove: React.PropTypes.func,               // method to handle removal of the value
    value: React.PropTypes.object.isRequired,     // the option object for this value
  },

  renderLabel () {
    return (
      <span className={'Select-value-label'} role="option" aria-selected="true" id={this.props.id}>
        {(!this.props.id.endsWith("0")) && <span>, </span>}
        {this.props.children}
      </span>
    );
  },

  render () {
    return (
      <div className={classNames('Select-value', this.props.value.className)}
        title={this.props.value.title}
        >
        {this.renderLabel()}
      </div>
    );
  }

});

module.exports = Value;



// WEBPACK FOOTER //
// ./src/components/Value/Value.js